import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';

//https://github.com/TanStack/query/discussions/372#discussioncomment-6023276
const MAX_RETRIES = 3;
const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404];
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (failureCount > MAX_RETRIES) {
          return false;
        }

        if (
          isAxiosError(error) &&
          HTTP_STATUS_TO_NOT_RETRY.includes(error.response?.status ?? 0)
        ) {
          console.log(`Aborting retry due to ${error.response?.status} status`);
          return false;
        }

        return true;
      }
    }
  }
})

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { isAxiosError } from 'axios'
import { createTheme, MantineProvider } from '@mantine/core'

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const theme = createTheme({
  components: {
    TextInput: {
      styles: {
        label: { color: '#FAFAFA' },
        input: {
          border: "none",
          color: "#FAFAFA",
          backgroundColor: '#FFFFFF0D', // 設定背景色
          '&:focus': {
            backgroundColor: '#FFFFFF0D',
          }
        }
      }
    },
    Select: {
      styles: {
        label: { color: '#FAFAFA' },
        input: {
          border: "none",
          color: "#FAFAFA",
          backgroundColor: '#FFFFFF0D', // 設定背景色
          '&:focus': {
            backgroundColor: '#FFFFFF0D',
          }
        }
      }
    },
    Textarea: {
      styles: {
        label: { color: '#FAFAFA' },
        input: {
          color: "#FAFAFA",
          backgroundColor: '#FFFFFF0D',
          border: "none",
          '&:focus': {
            backgroundColor: '#FFFFFF0D',
          }
        }
      }
    }
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          <Notifications />
          <RouterProvider router={router} />
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>,
)

console.log(`Build:${BUILD_HASH}(${new Date(BUILD_DATE).toLocaleString()})`)